import React from "react";
import { Props } from "./types";

function ArrowIcon(props: Props) {
  return (
    <svg className={props.className} viewBox="0 0 10 5">
      <path
        id="Polygone_154"
        d="M4.462.645a.7.7,0,0,1,1.076,0L9.043,4.852A.7.7,0,0,1,8.505,6H1.495A.7.7,0,0,1,.957,4.852Z"
        transform="translate(10 5) rotate(-180)"
      />
    </svg>
  );
}

export { ArrowIcon };
